export const productPath = (product) =>
  `/catalogue/${product.category}/${product.subcategory}/${product.slug || product.id}`;

export default productPath;
